import { useMediaQuery, useTheme } from '@material-ui/core';

export const useIsMediumUp = () => useMediaQuery(useTheme().breakpoints.up('md'));

export const useIsMediumDown = () => useMediaQuery(useTheme().breakpoints.down('md'));

export const useIsLargeUp = () => useMediaQuery(useTheme().breakpoints.up('lg'));

export const useIsXsDown = () => useMediaQuery(useTheme().breakpoints.down('xs'));

/** Viewport „telefon” (0-599px) — zgodne z `breakpoints.only('xs')` w stylach. */
export const useIsXsOnly = () => useMediaQuery(useTheme().breakpoints.only('xs'));

export const useIsSmDown = () => useMediaQuery(useTheme().breakpoints.down('sm'));

export const useIsSmUp = () => useMediaQuery(useTheme().breakpoints.up('sm'));

export const useIsMdUp = () => useMediaQuery(useTheme().breakpoints.up('md'));

export const useIsMdDown = () => useMediaQuery(useTheme().breakpoints.down('md'));

export const useIsLgUp = () => useMediaQuery(useTheme().breakpoints.up('lg'));

export const useIsXlUp = () => useMediaQuery(useTheme().breakpoints.up('xl'));
